export default "__VITE_PUBLIC_ASSET__9aca5424__"